import * as en from './languages/en.json';
import * as de from './languages/de.json';

import { hass } from '../helpers'

const languages = {
  en: en,
  de: de,
};

const fallbackLanguage = 'de';

const isLanguageSupported = (language) => {
  return Object.keys(languages).includes(language);
};

const translationExistsForLanguage = (section, key, language) => {
  return languages[language][section] && languages[language][section][key];
};

export function localize(string, search = '', replace = '') {
  const section = string.split('.')[0];
  const key = string.split('.')[1];

  let language = ( (hass() && hass().language) || 'en').replace(/['"]+/g, '').replace('-', '_');
  if (!isLanguageSupported(language) || !translationExistsForLanguage(section, key, language)) {
    language = fallbackLanguage;
  }

  if (!translationExistsForLanguage(section, key, language)) {
    return string;
  }

  let translated = languages[language][section][key];

  if (search !== '' && replace !== '') {
    translated = translated.replace(search, replace);
  }
  return translated;
}
